(function () {
    'use strict';

    // @ngInject
    function NavigationServiceCtor($state, AppStates, UiPersistenceService, ModalService, PretrialersService, $window, _,
                                   Enums, AbTestService, $q, UsersManager) {

        this.$state = $state;
        this.AppStates = AppStates;
        this.UiPersistenceService = UiPersistenceService;
        this.PretrialersService = PretrialersService;
        this.$window = $window;

        this.Enums = Enums;
        this.AbTestService = AbTestService;
        this.$q = $q;
        this._ = _;

        //////////////////////////////////////////
        // THIS FLAG IS DEPRECATED! WE NEED TO
        // CLEAN UP ALL LOCATIONS THAT USES THIS
        //////////////////////////////////////////
        this.showTopNav = true;
        this._backToState = null;
    }

    Services.NavigationService = Class({
        constructor: NavigationServiceCtor,

        isRouteActive: function isRouteActive(root) {
            return this.$state.current.name && this.$state.current.name.indexOf(root) !== -1;
        },

        goHistoryBack: function goHistoryBack() {
            if (this.$state.previous) {
                this.$window.history.back();
            } else if (this.PretrialersService.shouldShowCleanAtwsUI()){
                return this.PretrialersService.gotoLastWorkspace();
            }
            else{
                this.$state.go(this.AppStates.root_core_navigation_home);
            }
        },

        setBackToState : function setBackToState(state) {
            this._backToState = state;
        },

        clearBackToState: function clearBackToState() {
            this.setBackToState(null);
        },

        getBackToState : function getBackToState() {
            return this._backToState;
        },

        isNavSecondLevelNoTitle: function isNavSecondLevelNoTitle() {
            return this.$state.$current.data &&
                   this.$state.$current.data.secondLevelNavNoTitle;
        },

        isNavSecondLevelWithTitle: function isNavSecondLevelWithTitle() {
            return this.$state.$current.data &&
                   this.$state.$current.data.secondLevelNavWithTitle;
        },

        isNavSinglePage: function isNavSinglePage() {
            return this.$state.$current.data &&
                   this.$state.$current.data.singlePageNav;
        },

        isWithoutNavigation: function isWithoutNavigation() {
            return this.$state.$current.data &&
                this.$state.$current.data.noNavigation;
        },

        isTopViewShadowDisabled: function isTopViewShadowDisabled() {
            return this.$state.$current.data &&
              this.$state.$current.data.disableTopViewShadow;
        },

        isNavCurrentPeople: function isNavCurrentPeople() {
            return this.$state.$current.includes[this.AppStates.root_core_navigation_creatives];
        },
        isNavCurrentContacts: function isNavCurrentContacts() {
            return this.$state.$current.includes[this.AppStates.root_core_navigation_contacts];
        },

        isNavSettingsMobile: function isNavSettingsMobile() {
            return this.$state.$current.includes[this.AppStates.root_core_navigation_settings_mobile];
        },

        isNavCurrentCommunity: function isNavCurrentCommunity() {
            return this.$state.$current.includes[this.AppStates.root_network_opportunities];
        },

        isNavCommunityPage: function isNavCommunityPage() {
            return this.$state.current.data && this.$state.current.data.communityPageNav;
        },

        registerPlusButtonCallback: function registerPlusButtonCallback(callback) {
            this.plusButtonCallback = callback;
        },

        unregisterPlusButtonCallback: function unregisterPlusButtonCallback() {
            this.plusButtonCallback = null;
        },

        onPlusButtonClickCallback: function onPlusButtonClickCallback() {
            this._.isFunction(this.plusButtonCallback) && this.plusButtonCallback();
        }
    });
}());
